module.exports = __webpack_public_path__ + "5c22f520065331212b1123cc86e23254.png";